import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['input','summaryText','summaryPrice'];

  connect(){
    for (const x of this.inputTargets) {
      x.addEventListener('change', (e) => {
        const priceText = e.target.dataset.priceText;
        const priceNominal = e.target.dataset.priceNominal;

        this.summaryTextTarget.innerHTML = priceText;
        this.summaryPriceTarget.innerHTML = priceNominal;
      });
    }
  }
}
